/* =========================================================
   MÜNN · WISH · Landing Regalos Corporativos
   Los enlaces NO se editan aquí: se editan en munn-landing-config.js
   ========================================================= */

(function () {
  "use strict";

  var CATALOG_PLACEHOLDER = "PEGA_AQUI_EL_LINK_PUBLICO_DEL_CATALOGO";
  var WISH_PLACEHOLDER = "PEGA_AQUI_EL_LINK_DE_LOS_PRODUCTOS_WISH";

  function isValidUrl(value, placeholder) {
    if (!value || value === placeholder) return false;
    try {
      var url = new URL(value);
      return url.protocol === "https:" || url.protocol === "http:";
    } catch (error) {
      return false;
    }
  }

  function configureLink(element, url, placeholder) {
    if (!element) return;

    // Nunca se descarga: se abre para visualizar en el navegador
    element.removeAttribute("download");

    if (isValidUrl(url, placeholder)) {
      element.href = url;
      element.target = "_blank";
      element.rel = "noopener";
      element.removeAttribute("aria-disabled");
    } else {
      // Enlace pendiente: no lleva a una página inexistente
      element.setAttribute("href", "#");
      element.setAttribute("aria-disabled", "true");
      element.addEventListener("click", function (event) {
        event.preventDefault();
      });
      console.warn(
        "[Landing] Falta configurar un enlace en munn-landing-config.js: " + element.id
      );
    }
  }

  function setupLinks() {
    var config = window.LANDING_CONFIG || {};

    configureLink(
      document.querySelector("#catalog-link"),
      config.catalogUrl,
      CATALOG_PLACEHOLDER
    );

    configureLink(
      document.querySelector("#wish-link"),
      config.wishUrl,
      WISH_PLACEHOLDER
    );
  }

  function startAnimations() {
    // Doble requestAnimationFrame: asegura que el estado inicial se pinte antes de animar
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.documentElement.classList.add("is-loaded");
      });
    });
  }

  function init() {
    setupLinks();
    startAnimations();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();